<script>
  import {
    VCard
  } from 'vuetify/lib'
  export default {
    name: 'wh-card',
    extends: VCard
  };
</script>